import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

// @material-ui/core components
import { withStyles } from '@material-ui/core/styles';

// Styles
import styles from './styles';

const Footer = class extends React.PureComponent {
  render() {
    const { classes } = this.props;

    return (
      <footer className={classes.footer}>
        <Link to={'/policy'} className={classes.link}>
          <p >
            Políticas BID
          </p>
        </Link>
      </footer>
    );
  }
};

Footer.propTypes = {
  classes: PropTypes.object,
};

export default withStyles(styles)(Footer);
